import { SmartLink, SmartLinkProps } from '@components';
import { useAppSelector } from '@hooks';
import { getSpecialPage, SystemPages } from '@store/app/app.slice';

export type SystemPageLinkProps = SmartLinkProps & {
  pageType: keyof SystemPages;
};

export const SystemPageLink = ({ pageType, ...rest }: SystemPageLinkProps) => {
  try {
    const pageUrl = useAppSelector(getSpecialPage(pageType));
    const baseUrl = pageUrl || '';
    return baseUrl ? <SmartLink href={baseUrl} {...rest} /> : <></>;
  } catch {
    console.warn('Invalid url');
    return <></>;
  }
};

export const NotFoundPageLink = (props: SmartLinkProps) => (
  <SystemPageLink pageType='notFoundPage' {...props} />
);
export const ServerErrorPageLink = (props: SmartLinkProps) => (
  <SystemPageLink pageType='errorPage' {...props} />
);
export const ForbiddenPageLink = (props: SmartLinkProps) => (
  <SystemPageLink pageType='forbiddenPage' {...props} />
);
export const LoginPageLink = (props: SmartLinkProps) => (
  <SystemPageLink pageType='loginPage' {...props} />
);
export const ForgottenPasswordPageLink = (props: SmartLinkProps) => (
  <SystemPageLink pageType='forgotPasswordPage' {...props} />
);
export const ResetPasswordPageLink = (props: SmartLinkProps) => (
  <SystemPageLink pageType='resetPasswordPage' {...props} />
);
